<template>
    <div class="menu-search">
        <div class="menu-search__inner">
            <form class="menu-search__form">
                <div class="menu-search__input-wrap">
                    <input type="text" class="input menu-search__input" name="">
                </div>
                <button type="submit" class="menu-search__submit">
                    <svg class="search-icon" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10.0328" cy="10.0294" r="8.2945" stroke-width="1.5" />
                        <path d="M15.8472 15.8438L21.6615 21.6581" stroke-width="1.5" />
                    </svg>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
  name: 'the-menu-search',
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../../assets/css/system/_vars';
    @import '../../assets/css/system/_mixins';

    .menu-search {
        padding: 15px;
        background-color: $color_second-dark;

        &__form {
            display: flex;
            flex-flow: row nowrap;
        }

        &__inner {
            border-radius: 3px;
            box-shadow: 0 4px 4px $color_second-shadow;
            overflow: hidden;
        }

        &__input-wrap {
            width: 100%;
            height: 40px;
        }

        &__input {
            border: none;
            border-radius: 0;
            height: 100%;
            width: 100%;
            padding: 10px 15px;

            &:hover {
                border: none;
            }

            &:focus {
                box-shadow: none;
            }
        }

        &__submit {
            color: $color_second-light;
            background-color: $color_main;
            cursor: pointer;

            &:active {
                color: $color_controls-click;
            }
        }

        &_deactive {
            pointer-events: none;

            .menu-search__submit {
                color: $color_deactive;
            }
        }
    }
</style>
